const CURRENCY_SYMBOLS = { USD: "$", EUR: "€", GBP: "£", NGN: "₦", GHS: "₵", KES: "KSh", ZAR: "R", INR: "₹", CAD: "C$", AUD: "A$", JPY: "¥", CNY: "¥", EGP: "E£", AED: "د.إ" };

/**
 * Shared "From $X" / "Free" price summary, derived from an event's real multi-tier
 * `ticketTypes` array (see EventResource) rather than the old single flat price/is_paid
 * fields -- used on the details page, the booking sidebar, and every event card. "Free" wins
 * whenever at least one free ticket type still has room, matching Eventbrite's own badge
 * behavior; otherwise the cheapest remaining paid/donation type's price; a legacy event with no
 * ticketTypes loaded falls back to its old flat price/is_paid fields so nothing regresses.
 */
export function getEventPriceSummary(event, { freeLabel = "Free", fromLabel = "From" } = {}) {
  const ticketTypes = event?.ticketTypes || [];

  if (ticketTypes.length > 0) {
    const hasAvailableFree = ticketTypes.some(
      (tt) => tt.type === "free" && (tt.quantityAvailable == null || tt.soldCount < tt.quantityAvailable)
    );
    if (hasAvailableFree) return { label: freeLabel, isFree: true };

    const paidTypes = ticketTypes.filter((tt) => tt.type !== "free");
    if (paidTypes.length === 0) return { label: freeLabel, isFree: true };

    const cheapest = paidTypes.reduce((min, tt) => (tt.price != null && tt.price < min.price ? tt : min), paidTypes[0]);
    const symbol = CURRENCY_SYMBOLS[cheapest.currency] || cheapest.currency || "";
    return { label: `${fromLabel} ${symbol}${Number(cheapest.price || 0).toLocaleString()}`, isFree: false };
  }

  if (event?.paid_event) {
    const symbol = CURRENCY_SYMBOLS[event.currency] || event.currency || "";
    return { label: `${symbol}${Number(event.price || 0).toLocaleString()}`, isFree: false };
  }

  return { label: freeLabel, isFree: true };
}

export function formatMoney(amount, currency) {
  const symbol = CURRENCY_SYMBOLS[currency] || currency || "";
  return `${symbol}${Number(amount || 0).toLocaleString()}`;
}

export function youtubeEmbedId(url) {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : null;
}
